import clsx from 'clsx'
import React from 'react'

import { Star } from '@/components-latest/primitives/Icons'

import Styles from './ReviewStars.module.scss'

type Props = {
  rating: number
  className?: string
  size?: 'small' | 'big'
}

const ReviewStars = React.memo(
  ({ rating = 0, className, size = 'big' }: Props) => {
    const numberArray = new Array(5).fill(null).map((_, index) => index + 1)

    const roundedRating = Math.round(rating)

    return (
      <div className={clsx(Styles.wrapper, className)}>
        {numberArray.map(number => (
          <Star
            key={number}
            data-testid={`star-number-${number}`}
            data-filled={roundedRating >= number}
            className={clsx(Styles.star, Styles[size], {
              [Styles.filled]: roundedRating >= number
            })}
          />
        ))}
      </div>
    )
  }
)

ReviewStars.displayName = 'ReviewStars'
export default ReviewStars
